export default __webpack_public_path__ + "static/media/7.fe3107d0.jpg";